// Module
var code = "<input [name]=\"name\" type=\"file\" class=\"form-control filestyle\" (change)=\"manageFile($event)\"> ";
// Exports
module.exports = code;